import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../store/rootReducer';
import TabsComponent from '../../../../common/Tabs';
import { common_container } from '../../../dealList/components/deals/TopCard';
import DesktopUpdatedDocuments from './Desktop';
import InvestmentsExecutedAgreements from './ExecutedAgreements';
import UpdatePortfolioDocMobile from './Mobile';

const InvestmentUpdatedDocuments: React.FC = () => {
    const [activeTab, setTab] = useState('historical');
    const list = useSelector((state: RootState) => state.investments.updatePortfolioDoc);

    return (
        <div className={`bg-[#F1F7FF] py-4 w-full ${common_container}`}>
            <div className="flex justify-between items-center my-4">
                <p className="w-full text-[#152C52] text-left WorkSans-Semibold font-semibold text-xl md:text-3xl">
                    Portfolio Document Updates
                </p>
            </div>
            <div className="mb-6">
                <TabsComponent
                    tabs={[
                        { title: 'HISTORICAL', key: 'historical' },
                        { title: 'UPCOMING', key: 'upcoming' },
                        { title: 'EXECUTED AGREEMENTS', key: 'executed_agreements' },
                    ]}
                    activeTab={activeTab}
                    setActiveTab={setTab}
                    inactiveClass="bg-white text-[#8AA8D8] cursor-pointer"
                />
            </div>

            {activeTab === 'historical' ? (
                <>
                    {' '}
                    <div className="hidden md:block w-full">
                        <DesktopUpdatedDocuments
                            list={list.filter((d) => moment(moment(d.obligationDate?.date)).isBefore(moment()))}
                        />
                    </div>
                    <div className="flex md:hidden w-full">
                        <UpdatePortfolioDocMobile
                            list={list.filter((d) => moment(moment(d.obligationDate?.date)).isBefore(moment()))}
                        />
                    </div>
                </>
            ) : activeTab === 'upcoming' ? (
                <>
                    {' '}
                    <div className="hidden md:block w-full">
                        <DesktopUpdatedDocuments
                            list={list.filter((d) => moment(moment(d.obligationDate?.date)).isSameOrAfter(moment()))}
                        />
                    </div>
                    <div className="flex md:hidden w-full">
                        <UpdatePortfolioDocMobile
                            list={list.filter((d) => moment(moment(d.obligationDate?.date)).isSameOrAfter(moment()))}
                        />
                    </div>
                </>
            ) : (
                <InvestmentsExecutedAgreements />
            )}
        </div>
    );
};

export default InvestmentUpdatedDocuments;
